import React from 'react';

const miniEvents = [
  {
    logo: 'geoguessr.svg',
    title: 'Geoguessr',
    description: <p>Awarded to the winner of each map in the Geoguesser Mini-event! Learn more about how to play at <a href="https://www.geoguessr.com/">https://www.geoguessr.com/</a></p>,
    subcategories: [
      {
        title: 'Three Winners',
        prize: '$20 Amazon Gift Card',
      },
    ],
  },
  {
    logo: 'john-deere.svg',
    title: 'Stomp and Spray',
    subtitle: 'Sponsored by John Deere',
    description: <p>Awarded to the top two scorers of the Stomp and Spray Game (Created by John Deere)! (See Discord for more details)</p>,
    subcategories: [
      {
        title: 'First Place',
        prize: '$25 Amazon Giftcard',
      },
      {
        title: 'Second Place',
        prize: '$15 Amazon Giftcard',
      },
    ],
  },
  {
    logo: 'caterpillar.svg',
    title: 'Code in the Dark',
    subtitle: 'Sponsored by Caterpillar',
    description: <p>Awarded to the best recreation of the provided webpage at the Code in the Dark Event!</p>,
    subcategories: [
      {
        title: 'First Place',
        prize: '$75 Amazon Giftcard',
      },
      {
        title: 'Second Place',
        prize: '$50 Amazon Giftcard',
      },
      {
        title: 'Third Place',
        prize: '$25 Amazon Giftcard',
      },
    ],
  },
  {
    logo: 'typeracer.svg',
    title: 'Typeracer',
    description: <p>Awarded to the three fastest typers at the Typeracer event at HackIllinois!</p>,
    subcategories: [
      {
        title: 'First Place',
        prize: '$25 Amazon Giftcard',
      },
      {
        title: 'Second Place',
        prize: '$20 Amazon Giftcard',
      },
      {
        title: 'Third Place',
        prize: '$15 Amazon Giftcard',
      },
    ],
  },
  {
    logo: 'hackillinois.svg',
    title: 'League of Legends Tournament',
    description: <p>Cook up a battle in League of Legends! Play with old and new friends or watch the tournament on Twitch—let the games begin!</p>,
    subcategories: [
      {
        title: 'First Place',
        prize: '1st Place: $25 Amazon Gift Card per Team Member',
      },
      {
        title: 'Second Place',
        prize: '2nd Place: $15 Amazon Gift Card per Team Member',
      },
    ],
  },
];

export default miniEvents;
